import React, { FC } from 'react'

import { useRouter } from 'next/navigation'

import { UserAssignProjects } from 'src/components/organisms'

import { Routes } from 'src/routes'
import { AssignedProjectEntity, ProfileEntity } from 'src/types'

type Props = {
  me: ProfileEntity
  projects: AssignedProjectEntity[]
  selectedProjectId?: string
  className?: string
}

export const MyPageAssignProjects: FC<Props> = ({ me, projects, selectedProjectId, className }) => {
  const router = useRouter()

  return (
    <div className={className}>
      <UserAssignProjects
        user={me}
        projects={projects}
        defaultSelectedProjectId={selectedProjectId}
        onClickRow={project =>
          router.push(Routes.ProjectDetail.buildPath({ projectId: project.id }))
        }
      />
    </div>
  )
}
